import { memo } from 'react'
import { HeaderLogo } from '~/components/header/HeaderLogo'
import { SideMenuContainer } from '~/components/header/sd/SideMenuContainer'
import { css } from '~/styled-system/css'
import { center } from '~/styled-system/patterns'
import { HeaderWrapper } from '../HeaderWrapper'

export const SDHeader = memo(_SDHeader)

function _SDHeader() {
  return (
    <HeaderWrapper>
      <header
        className={center({
          position: 'relative',
          py: '2',
          borderBottom: 'medium',
          minHeight: '[42px]',
        })}
      >
        <HeaderLogo />
        <SideMenuContainer className={css({ position: 'absolute', right: '2' })} />
      </header>
    </HeaderWrapper>
  )
}
